#
# Logging
#
window.$l = (message) ->
  console.log message if console
